import { useMemo } from "react";
import styles from "./productsGrid.module.scss";

export type PackagingProps = {
  packaging?: string | number;
};

export default function Packaging({ packaging }: PackagingProps) {
  const isValidPackaging = useMemo(() => {
    if (!packaging) {
      return false;
    } else if (typeof packaging === "number") {
      return true;
    } else {
      return packaging.trim() !== "" && packaging.toLowerCase() !== "n/a";
    }
  }, [packaging]);

  if (isValidPackaging) {
    return <p className={`mb-0 ${styles.packagingInfo}`} dangerouslySetInnerHTML={{ __html: packaging as string }}></p>;
  } else {
    return null;
  }
}
